import styled, { keyframes } from "styled-components";
import { colors, values } from "~/assets/js/theme/constants";

const ripple = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(10);
    opacity: 0.375;
  }
  100% {
    transform: scale(35);
    opacity: 0;
  }
`;

export const Content = styled.div`
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

export const Ripple = styled.span`
    width: 16px;
    height: 16px;
    position: absolute;
    background: ${colors.RIPPLE}30;
    display: block;
    content: "";
    border-radius: 9999px;
    opacity: 1;
    animation: ${values.RIPPLE_TRANSITION_DURATION} ease 1 forwards ${ripple};
`;
